export function ft_csvToArray(text: string): string[][] {
	let currentRow: string[] = [''];
	const result: string[][] = [];
	let previousChar = '';
	let currentIndex = 0;
	let withinQuotes = false;

	// Détection du séparateur le plus probable
	const separators = [',', ';', '\t'];
	let detectedSeparator = separators[0]; // Par défaut, on utilise la virgule

	// Compte des occurrences de chaque séparateur dans les premières lignes
	const lines = text.split('\n').slice(0, 10); // Analyse des 10 premières lignes
	const separatorCounts = separators.map(sep => lines.reduce((count, line) => count + (line.split(sep).length - 1), 0));
	const maxCount = Math.max(...separatorCounts);

	// Si un séparateur semble dominer, on l'utilise
	if (maxCount > 0)
		detectedSeparator = separators[separatorCounts.indexOf(maxCount)];

	for (let textIndex = 0; textIndex < text.length; textIndex++) {
		const currentChar: string = text[textIndex];
		if (currentChar === '"') {
			if (currentChar === previousChar && withinQuotes)
				currentRow[currentIndex] += currentChar;
			withinQuotes = !withinQuotes;
		} else if (currentChar === detectedSeparator && !withinQuotes) {
			currentIndex++;
			currentRow[currentIndex] = '';
		} else if (currentChar === '\n' && !withinQuotes) {
			if (previousChar === '\r')
				currentRow[currentIndex] = currentRow[currentIndex].slice(0, -1);
			if (currentRow.some(cell => cell.trim() !== ''))
				result.push(currentRow);
			currentRow = [''];
			currentIndex = 0;
		} else
			currentRow[currentIndex] += currentChar;
		previousChar = currentChar;
	}

	if (currentRow.some(cell => cell.trim() !== ''))
		result.push(currentRow);

	return result;
}
